import { themeStyles } from "./Data";
import { motion } from "framer-motion";

const ItemCard = ({ item, isActive, onClick, theme = "blue" }) => {
  const styles = themeStyles[theme];
  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: [0.25, 1, 0.5, 1] },
    },
  };

  return (
    <motion.li role="listitem" variants={cardVariants}>
      <motion.button
        type="button"
        aria-pressed={isActive}
        onClick={() => onClick(item.id)}
        onFocus={() => onClick(item.id)}
        className={`w-full text-left py-2 px-3 rounded-xl border-2 transition-all duration-300 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 flex items-center space-x-2.5 cursor-pointer ${
          isActive ? styles.active : styles.inactive
        } ${styles.focus}`}
        whileHover={{ scale: isActive ? 1.05 : 1.02 }}
        whileTap={{ scale: 0.98 }}
      >
        <motion.div
          className={`flex-shrink-0 w-9 h-9 rounded-lg flex items-center justify-center transition-colors duration-300 ${
            isActive ? "bg-slate-100" : "bg-transparent"
          } ${styles.icon}`}
          whileHover={{ rotate: 15, scale: 1.1 }}
        >
          {item.icon}
        </motion.div>
        <div>
          <h4 className={`font-bold text-xl ${styles.title}`}>
            {item.title}
          </h4>
          <p className="text-base text-gray-700 mt-1">{item.description}</p>
        </div>
      </motion.button>
    </motion.li>
  );
};

export default ItemCard;
